// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"25bc482974d7237baddd","883":"ae85a44213f63b18d199"}[chunkId] + ".js";
};